<template>
  <div>
    <v-container
      fluid
      class="fill-height"
    >
      <v-content>
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            md="8"
          >
            <v-card class="elevation-12">
              <v-data-table
                :headers="headers"
                :items="items"
                :items-per-page="5"
                class="elevation-1"
                no-data-text="No hay contactos registrados."
                :loading="loading"
                loading-text="Cargando contactos registrados."
              >
                <template v-slot:top>
                  <v-toolbar
                    flat
                    color="white"
                  >
                    <v-btn
                      color="primary"
                      dark
                      @click="openForm"
                    >
                      Nuevo contacto
                    </v-btn>
                  </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    color="#63C891"
                    @click="editItem(item)"
                  >
                    edit
                  </v-icon>
                  <v-icon
                    small
                    color="#F99191"
                    @click="deleteItem(item)"
                  >
                    delete
                  </v-icon>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-content>
    </v-container>
    <contact-form
      :item="selectedItem"
      :show="showForm"
      @close="showForm = false"
      @updateList="updateList"
    />
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import ContactForm from '@/components/Contact/ContactForm.vue';

export default {
  name: 'Contacts',
  components: {
    ContactForm,
  },
  data: () => ({
    headers: [
      { text: 'Nombre', value: 'name', align: 'center' },
      { text: 'Apellido', value: 'lastname', align: 'center' },
      { text: 'Email', value: 'email', align: 'center' },
      {
        text: 'Acciones',
        value: 'actions',
        align: 'center',
        sortable: false,
      },
    ],
    items: [],
    showForm: false,
    selectedItem: null,
    loading: false,
  }),
  watch: {
    showForm(val) {
      if (val === false) {
        this.selectedItem = null;
      }
    },
  },
  mounted() {
    this.updateList();
  },
  methods: {
    editItem(item) {
      this.selectedItem = item;
      this.openForm();
    },
    deleteItem(item) {
      Swal.fire({
        title: '¿Estas seguro?',
        text: 'Esta acción no se puede deshacer...',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminar!',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.value) {
          this.axios.delete(`/api/contacts/${item.id}`)
            .then((response) => {
              if (response.status === 204) {
                Swal.fire(
                  'Eliminado!',
                  'El contacto ha sido eliminado correctamente.',
                  'success',
                )
                  .then(() => {
                    this.updateList();
                  });
              }
            })
            .catch((error) => {
              Swal.fire(
                'Error',
                error.response.message,
                'error',
              );
            });
        } else {
          Swal.fire(
            'Cancelado',
            'El contacto no ha sido eliminado.',
            'success',
          );
        }
      });
    },
    openForm() {
      this.showForm = true;
    },
    updateList() {
      this.loading = true;
      this.axios.get('/api/contacts')
        .then((response) => {
          this.loading = false;
          if (response.status === 200) {
            this.items = response.data;
          }
        })
        .catch((error) => {
          this.loading = false;
          if (error.response.status === 401) {
            Swal.fire({
              title: 'Lo sentimos',
              text: 'Su sesión ha expirado.',
              icon: 'error',
            })
              .then(() => {
                this.$emit('logout');
              });
          }
        });
    },
  },
};
</script>
